/**
 * That class is created for basic oauth API to be concordant with other services
 * because we need to make a research of using our instances outside of module
 * injections/inversions and extends, before we could cut off that :(
 */
var User = /** @class */ (function () {
    function User(data) {
        this.data = data;
        this.profile = data.profile;
        var now = this._dateNow();
        this.expires_at = now + data.expires_in;
        this.scopes = data.profile.scope.split(' ');
    }
    User.prototype._dateNow = function () {
        return Math.floor(Date.now() / 1000);
    };
    Object.defineProperty(User.prototype, "expired", {
        get: function () {
            var now = this._dateNow();
            if (now - 6000 > this.expires_at) {
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return User;
}());
export { User };
//# sourceMappingURL=User.js.map